import { BrandNavApp } from "components/common/BrandNavApp";
import { NavApp } from "components/common/NavApp";
import { useState } from "react";
import "./HeaderApp.scss";

export function HeaderApp() {
    const [showMenu, setShowMenu] = useState(false);
    return (
        <header className="header">
            <BrandNavApp showMenu={showMenu} setShowMenu={setShowMenu} />
            <NavApp showMenu={showMenu} />
        </header>
    )
}